<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [canGoBack]="true"
      [title]="'Needs Work'" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  @if (loaded) {
    <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">
      <tidy-card>
        <tidy-row>
          <tidy-text
            [body]="'We\'re sorry that you weren\'t happy with'" /><span>&nbsp;</span>
            <tidy-text
              [body]="hkName + '.'" /><span>&nbsp;</span>
              <tidy-text
                [body]="'We would love to get this right. What Happened?'" />
            </tidy-row>
            <form [formGroup]="whatHpndForm">
              @for (key of keys; track key) {
                <tidy-checkbox
                  [formControlName]="key"
                  [form]="whatHpndForm.controls.key"
                  [items]="[{viewValue: questions[key] , value: true}]" />
              }
            </form>
          </tidy-card>
          <tidy-button
            [text]="'Next'"
            [action]="boundSendFeedback"
            class="primary" />
        </tidy-wrapper>
      }
    </ng-template>

    @if (!isRightSideContent) {
      <app-scroll-wrapper [templateContent]="content" />
    }

    @if (isRightSideContent) {
      <ion-content class="ion-content-right-column">
        <ng-container *ngTemplateOutlet="content" />
      </ion-content>
    }
